
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external-wallets",
      function () {
        return require("private-next-pages/external-wallets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/external-wallets"])
      });
    }
  